import { getDB } from "./schema";
import type { StoredDocument } from "./types";

export async function putDocument(doc: StoredDocument): Promise<void> {
  const db = await getDB();
  await db.put("documents", doc);
}

export async function getDocument(id: string): Promise<StoredDocument | undefined> {
  const db = await getDB();
  return db.get("documents", id);
}

export async function listDocuments(): Promise<StoredDocument[]> {
  const db = await getDB();
  const all = await db.getAllFromIndex("documents", "by-uploadedAt");
  return all.reverse();
}

export async function findDocumentByHash(
  hash: string,
): Promise<StoredDocument | undefined> {
  const db = await getDB();
  return db.getFromIndex("documents", "by-hash", hash);
}

export async function deleteDocument(id: string): Promise<void> {
  const db = await getDB();
  await db.delete("documents", id);
}

export async function getDocuments(ids: string[]): Promise<StoredDocument[]> {
  if (ids.length === 0) return [];
  const db = await getDB();
  const tx = db.transaction("documents");
  const results = await Promise.all(ids.map((id) => tx.store.get(id)));
  await tx.done;
  return results.filter((d): d is StoredDocument => d !== undefined);
}

/** Move documents to a folder (or to root when folder is null) in a single
 *  read/write transaction. Missing ids are skipped. */
export async function setDocumentFolder(
  ids: string[],
  folder: string | null,
): Promise<void> {
  if (ids.length === 0) return;
  const db = await getDB();
  const tx = db.transaction("documents", "readwrite");
  await Promise.all(
    ids.map(async (id) => {
      const doc = await tx.store.get(id);
      if (doc) await tx.store.put({ ...doc, folder });
    }),
  );
  await tx.done;
}
